import SectionHeading from "@/components/base/SectionHeading";
import ScrollReveal from "@/components/base/ScrollReveal";
import { BUSINESSES } from "@/constants/site";

export default function BusinessSection() {
  return (
    <section id="service" className="w-full scroll-mt-16 bg-background-100 py-20 md:py-28">
      <div className="mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
        <ScrollReveal>
          <div>
            <SectionHeading label="事業内容" en="SERVICE" />
            <p className="mt-8 max-w-2xl font-body text-[15px] leading-[2] text-foreground-700">
              「売る」「伝える」「育てる」「効率化する」「届ける」。
              REVRA Groupは、営業・マーケティング・人材育成・DX・飲食の6つの事業で、
              お客様と社会の課題に向き合っています。
            </p>
          </div>
        </ScrollReveal>

        <div className="mt-14 grid grid-cols-1 gap-px border border-background-300/70 bg-background-300/70 sm:grid-cols-2 lg:grid-cols-3">
          {BUSINESSES.map((business, index) => (
            <ScrollReveal key={business.no} delay={index * 80}>
              <article className="flex h-full flex-col bg-background-50 p-7 transition-colors duration-500 hover:bg-background-100 md:p-10">
                <div className="flex items-start justify-between">
                  <span className="font-label text-3xl tracking-[0.1em] text-accent-600">
                    {business.no}
                  </span>
                  <span className="font-label text-[11px] tracking-[0.24em] text-secondary-500">
                    {business.en}
                  </span>
                </div>
                <h3 className="mt-6 font-heading text-lg font-medium tracking-[0.04em] text-foreground-950 md:mt-8">
                  {business.title}
                </h3>
                <p className="mt-4 font-body text-sm leading-[1.9] text-foreground-700">
                  {business.desc}
                </p>
                <p className="mt-3 border-l-2 border-accent-500 pl-3 font-body text-sm font-medium leading-[1.8] text-foreground-950">
                  {business.value}
                </p>
                <ul className="mt-6 flex flex-col gap-2">
                  {business.points.map((point) => (
                    <li
                      key={point}
                      className="flex items-center gap-2 font-body text-xs text-foreground-600"
                    >
                      <span className="h-px w-4 bg-accent-500" />
                      {point}
                    </li>
                  ))}
                </ul>
              </article>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
